<div class="schedule-summary-main">
  <div class="schedule-summary-header">
    <h1 class="schedule-summary__heading">{{'ActivitySchedules' | translate}}</h1>
  </div>
  <div class="schedule-summary-content">
    @if (isSessionClass && !isOpenBooking) {
      <div>
        @for (dateSchedule of allAvailableDates; track dateSchedule; let index = $index) {
          <div class="schedule-summary__day">
            @if (isSessionClass) {
              <div class="schedule-summary__day-date">
                <mat-checkbox class="schedule-summary__checkbox" [checked]="dateSchedule.checked"
                  (change)="dateClicked($event.checked, index)">
                </mat-checkbox>
                {{dateSchedule.StartDate | localizeDate: 'dddd, MMMM DD YYYY'}}
              </div>
            }
            @if (isSessionClass) {
              <div class="schedule-summary__sessions">
                @for (session of dateSchedule.sessions; track session; let sessionIndex = $index) {
                  <mat-accordion>
                    <mat-expansion-panel class="panel">
                      <mat-expansion-panel-header>
                        <mat-panel-title>
                          <div class="schedule-summary__session">
                            <div class="schedule-summary__session-left">
                              <mat-checkbox class="schedule-summary__checkbox" [checked]="session.checked"
                                (change)="sessionClicked(index)" (click)="$event.stopPropagation()"
                                [(ngModel)]="session.checked">
                              </mat-checkbox>
                              {{'session' | translate}} {{sessionIndex + 1}}
                            </div>
                            <div class="schedule-summary__session-right">
                              {{session.Start | localizeDate: 'LT'}} - {{session.End | localizeDate: 'LT'}}
                            </div>
                          </div>
                        </mat-panel-title>
                      </mat-expansion-panel-header>
                      @if (session.RatePlanVariants.TotalBaseRate) {
                        <div class="schedule-summary__rate-row">
                          <div class="schedule-summary__rate-label">
                            <span class="schedule-summary__rate-label--main">{{'TotalBaseRate' | translate}}</span>
                          </div>
                          <div class="schedule-summary__rate">{{OperationCurrency}}
                          {{session.RatePlanVariants.TotalBaseRate | currencyDecimalFormatter}}</div>
                        </div>
                      }
                      @if (session.RatePlanVariants.LocationVariant) {
                        <div class="schedule-summary__rate-row">
                          <div class="schedule-summary__rate-label">
                            <span class="schedule-summary__rate-label">{{'LocationVariant' | translate}} <span
                              class="sub-text">({{'forTotalOf' | translate}} {{BookingSize}}
                            )</span>
                          </span>
                        </div>
                        <div class="schedule-summary__rate">{{OperationCurrency}}
                        {{session.RatePlanVariants.LocationVariant | currencyDecimalFormatter}}</div>
                      </div>
                    }
                    @if (session.RatePlanVariants.InstructorVariant) {
                      <div class="schedule-summary__rate-row">
                        <div class="schedule-summary__rate-label">
                          <span class="schedule-summary__rate-label">{{'InstructorVariant' | translate}} <span
                            class="sub-text">({{'forTotalOf' | translate}} {{BookingSize}}
                          )</span>
                        </span>
                      </div>
                      <div class="schedule-summary__rate">{{OperationCurrency}}
                      {{session.RatePlanVariants.InstructorVariant | currencyDecimalFormatter}}</div>
                    </div>
                  }
                  @if (session.bookingTypeVariants && session.bookingTypeVariants.length) {
                    <div class="schedule-summary__rate-row"
                      >
                      <div class="schedule-summary__rate-label">
                        <span class="schedule-summary__rate-label sub-label">{{'bookingType' | translate}} </span>
                      </div>
                    </div>
                  }
                  @for (variant of session.bookingTypeVariants; track variant) {
                    <div class="schedule-summary__rate-row">
                      <div class="schedule-summary__rate-label">
                        <span class="schedule-summary__rate-label--main">{{variant.BookingTypeName}}</span>
                        <span class="schedule-summary__rate-label--sub">{{variant.bookingTypes}}</span>
                      </div>
                      <div class="schedule-summary__rate">{{OperationCurrency}} {{variant.Variant |
                        currencyDecimalFormatter}}
                      </div>
                    </div>
                  }
                  @if (session.coverTypeVariants && session.coverTypeVariants.length) {
                    <div class="schedule-summary__rate-row"
                      >
                      <div class="schedule-summary__rate-label">
                        <span class="schedule-summary__rate-label sub-label">{{'coverType' | translate}} </span>
                      </div>
                    </div>
                  }
                  @for (variant of session.coverTypeVariants; track variant) {
                    <div class="schedule-summary__rate-row">
                      <div class="schedule-summary__rate-label">
                        <span class="schedule-summary__rate-label--main">{{variant.CoverTypeName}}</span>
                        <span class="schedule-summary__rate-label--sub">{{variant.covers}}</span>
                      </div>
                      <div class="schedule-summary__rate">{{OperationCurrency}} {{variant.Variant |
                        currencyDecimalFormatter}}
                      </div>
                    </div>
                  }
                  @if (session.MemberShipVariant) {
                    <div class="schedule-summary__rate-row">
                      <div class="schedule-summary__rate-label">
                        <span class="schedule-summary__rate-label--main">{{'MemberShipVariant' | translate}}</span>
                      </div>
                      <div class="schedule-summary__rate">{{OperationCurrency}} {{session.MemberShipVariant |
                      currencyDecimalFormatter}}</div>
                    </div>
                  }
                  @if (session.TotalAmount) {
                    <div class="schedule-summary__rate-row">
                      <div class="schedule-summary__rate-label">
                        <span class="schedule-summary__rate-label--main">{{'TotalSessionCharge' | translate}}</span>
                      </div>
                      <div class="schedule-summary__rate">{{OperationCurrency}} {{session.TotalAmount |
                      currencyDecimalFormatter}}</div>
                    </div>
                  }
                </mat-expansion-panel>
              </mat-accordion>
            }
          </div>
        }
      </div>
    }
  </div>
}
@if (!isSessionClass && !isOpenBooking) {
  <div>
    @for (dateSchedule of allAvailableDates; track dateSchedule; let index = $index) {
      <div class="schedule-summary__day">
        <div class="schedule-summary__session_class" style="background: #FFFFFF;">
          <div class="schedule-summary__day-date">
            {{dateSchedule.StartDate | localizeDate: 'dddd, MMMM DD YYYY'}} - {{dateSchedule.EndDate | localizeDate: 'dddd, MMMM DD YYYY'}}
          </div>
          <div class="column">
            @for (selectedDay of SelectedClassSchedule; track selectedDay; let index = $index) {
              <div>
                @if (selectedDay) {
                  @for (slot of selectedDay; track slot) {
                    <div class="schedule-summary__session_classes padding-10px">
                      <div class="schedule-summary__session-left">
                        {{dayOfWeek[index]}}
                      </div>
                      &nbsp;
                      <div class="schedule-summary__session-right">
                        {{slot.Start | localizeDate:'LT'}} - {{slot.End | localizeDate:'LT'}}
                      </div>
                    </div>
                  }
                }
              </div>
            }
          </div>
          @if (!SelectedClassSchedule || !SelectedClassSchedule.length) {
            <div class="column">
              @for (slot of selectedClassList; track slot) {
                <div class="schedule-summary__session_classes padding-10px">
                  <div class="schedule-summary__session-left">
                    {{dayOfWeek[slot.Dayofweek]}}
                  </div>
                  &nbsp;
                  <div class="schedule-summary__session-right">
                    {{timeConversion(slot.StartTime , SpecialMeal ,'Start') | localizeDate:'LT' }} -
                    {{timeConversion(slot.EndTime, SpecialMeal ,'End') | localizeDate:'LT'}}
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
}
@if (isOpenBooking) {
  <div class="schedule-summary__sessions">
    @for (slot of allAvailableDates; track slot; let slotIndex = $index) {
      <mat-accordion>
        <mat-expansion-panel class="panel">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="schedule-summary__session">
                <div class="schedule-summary__session-left">
                  <mat-checkbox class="schedule-summary__checkbox" [checked]="slot.checked"
                    (click)="$event.stopPropagation()" [(ngModel)]="slot.checked">
                  </mat-checkbox>
                  {{slot.StartTime | localizeDate: 'dddd, MMMM DD YYYY'}} &nbsp;
                  {{slot.StartTime | localizeDate:'LT'}} - {{slot.EndTime | localizeDate:'LT'}}
                </div>
                @if (showModifybtn) {
                  <div class="schedule-summary__session-right mod-btn-color">
                    <a (click)="modifySelected(slot)">{{'modify' | translate}}</a>
                  </div>
                }
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          @if (slot.RatePlanVariants?.TotalBaseRate) {
            <div class="schedule-summary__rate-row">
              <div class="schedule-summary__rate-label">
                <span class="schedule-summary__rate-label--main">{{'TotalBaseRate' | translate}}</span>
              </div>
              <div class="schedule-summary__rate">{{OperationCurrency}}
              {{slot.RatePlanVariants.TotalBaseRate | currencyDecimalFormatter}}</div>
            </div>
          }
          @if (slot.RatePlanVariants?.LocationVariant) {
            <div class="schedule-summary__rate-row">
              <div class="schedule-summary__rate-label">
                <span class="schedule-summary__rate-label">{{'LocationVariant' | translate}} <span
                  class="sub-text">({{'forTotalOf' | translate}} {{BookingSize}}
                )</span>
              </span>
            </div>
            <div class="schedule-summary__rate">{{OperationCurrency}}
            {{slot.RatePlanVariants.LocationVariant | currencyDecimalFormatter}}</div>
          </div>
        }
        @if (slot.RatePlanVariants?.InstructorVariant) {
          <div class="schedule-summary__rate-row">
            <div class="schedule-summary__rate-label">
              <span class="schedule-summary__rate-label">{{'InstructorVariant' | translate}} <span
                class="sub-text">({{'forTotalOf' | translate}} {{BookingSize}}
              )</span>
            </span>
          </div>
          <div class="schedule-summary__rate">{{OperationCurrency}}
          {{slot.RatePlanVariants.InstructorVariant | currencyDecimalFormatter}}</div>
        </div>
      }
      @if (slot.bookingTypeVariants && slot.bookingTypeVariants.length) {
        <div class="schedule-summary__rate-row">
          <div class="schedule-summary__rate-label">
            <span class="schedule-summary__rate-label sub-label">{{'coverType' | translate}} </span>
          </div>
        </div>
      }
      @if (slot.bookingTypeVariants) {
        <div>
          @for (variant of slot.bookingTypeVariants; track variant) {
            <div class="schedule-summary__rate-row">
              @if (variant.Variant) {
                <div class="schedule-summary__rate-label">
                  <span class="schedule-summary__rate-label--main">{{variant.BookingTypeName}}</span>
                  <span class="schedule-summary__rate-label--sub">{{variant.bookingTypes}}</span>
                </div>
              }
              <div class="schedule-summary__rate">{{OperationCurrency}} {{variant.Variant |
                currencyDecimalFormatter}}
              </div>
            </div>
          }
        </div>
      }
      @if (slot.coverTypeVariants && slot.coverTypeVariants.length) {
        <div class="schedule-summary__rate-row">
          <div class="schedule-summary__rate-label">
            <span class="schedule-summary__rate-label sub-label">{{'coverType' | translate}} </span>
          </div>
        </div>
      }
      @if (slot.coverTypeVariants) {
        <div>
          @for (variant of slot.coverTypeVariants; track variant) {
            <div class="schedule-summary__rate-row">
              @if (variant.Variant) {
                <div class="schedule-summary__rate-label">
                  <span class="schedule-summary__rate-label--main">{{variant.CoverTypeName}}</span>
                  <span class="schedule-summary__rate-label--sub">{{variant.covers}}</span>
                </div>
              }
              <div class="schedule-summary__rate">{{OperationCurrency}} {{variant.Variant |
                currencyDecimalFormatter}}
              </div>
            </div>
          }
        </div>
      }
      @if (slot.MemberShipVariant) {
        <div class="schedule-summary__rate-row">
          <div class="schedule-summary__rate-label">
            <span class="schedule-summary__rate-label--main">{{'MemberShipVariant' | translate}}</span>
          </div>
          <div class="schedule-summary__rate">{{OperationCurrency}} {{slot.MemberShipVariant |
          currencyDecimalFormatter}}</div>
        </div>
      }
      @if (slot.TotalAmount) {
        <div class="schedule-summary__rate-row">
          <div class="schedule-summary__rate-label">
            <span class="schedule-summary__rate-label--main">{{'TotalSessionCharge' | translate}}</span>
          </div>
          <div class="schedule-summary__rate">{{OperationCurrency}} {{slot.TotalAmount |
          currencyDecimalFormatter}}</div>
        </div>
      }
    </mat-expansion-panel>
  </mat-accordion>
}
</div>
}
</div>
<div class="schedule-summary__footer">
  @if ((!isSessionClass && !isOpenBooking) ? (  PartyData ? (PartyData.State !== PartyState.Seated) :true) : allAvailableDates.length > 0 ) {
    <app-button [buttontype]="cancelButton"
      (valueChange)="cancelClick()">
    </app-button>
  }
  @if (!gs.selectedSpecialMeal?.IsForStandbyReservations) {
    @if (!isOpenBooking && ((!isSessionClass && !isOpenBooking) ? (PartyData ? (PartyData.State !== PartyState.Seated) :true ) : (allAvailableDates.length > 0 ))) {
      <app-button [buttontype]="modifyButton"
        (valueChange)="modifyClick()">
      </app-button>
    }
  }
  @if (gs.additionalGuestPage && gs.additionalGuestRequired > 0) {
    <app-button [buttontype]="additionalGuestBtn"
    (valueChange)="additionalGuest()"></app-button>
  }

  @if (!ratePlanfromToken) {
    <app-button class="btn-class" [buttontype]="BookAnotherReservationBtn"
      (valueChange)="bookAnotherReservationBtn($event)">
    </app-button>
  }
  @if (gs.isSummaryFromCart) {
    <app-button class="btn-class" [buttontype]="backToSummarybtn"
      (valueChange)="backToCartSummary($event)">
    </app-button>
  }
</div>

</div>